import { WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from "../../constants";
import {
  VisitorSettingsDrawerButton,
  VisitorSettingsDrawerControlMenuItemWrapper as BaseVisitorSettingsDrawerControlMenuItem,
} from "../../controls";

export function VisitorWaitingSettingsControlButton() {
  return (
    <VisitorSettingsDrawerButton
      drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}

export function VisitorWaitingSettingsDrawerControlMenuItem() {
  return (
    <BaseVisitorSettingsDrawerControlMenuItem
      drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}
